// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconAdd.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconAdd = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H13C14.6569 16 16 14.6569 16 13V3C16 1.34315 14.6569 0 13 0H3ZM8 3C7.5816 3 7.24242 3.33918 7.24242 3.75758V7.24242H3.75758C3.33918 7.24242 3 7.5816 3 8C3 8.4184 3.33918 8.75758 3.75758 8.75758H7.24242V12.2424C7.24242 12.6608 7.5816 13 8 13C8.4184 13 8.75758 12.6608 8.75758 12.2424V8.75758H12.2424C12.6608 8.75758 13 8.4184 13 8C13 7.5816 12.6608 7.24242 12.2424 7.24242H8.75758V3.75758C8.75758 3.33918 8.4184 3 8 3Z" />
  </BaseIcon>
);

export default IconAdd;
